import React from "react";
import { Row, Tag } from "antd";



export const typeMap = {
    b: "Block",
    s: "Sleeve",
    m: "Model",
    mm: "Model of Models"
}


const fieldColorMap = {
    dividend: 'linear-gradient(to right, #211475 8px, #FFF 8px)',
    equity: 'linear-gradient(to right, #66E1DF  8px, #FFF 8px)',
    fixed: 'linear-gradient(to right, #dd1818  8px, #FFF 8px)',
    etf: 'linear-gradient(to right, #211475 8px, #FFF 8px)',
    growth: 'linear-gradient(to right, #1325AC 8px, #FFF 8px)',
    value: 'linear-gradient(to right, #1D267 8px, #FFF 8px)',
    mixed: 'linear-gradient(to right, #C33764 8px, #FFF 8px)',
}



const defaultAvatarStyle = {
    background: 'linear-gradient(to right, #1A1E23, rgb(13, 42, 76) 8px, #FFF 8px)'
};


export const PortfolioAvatars = ({ userTags,  maxWidth=100 }) => {
  let avatars = [];

  if (userTags) {
    Object.keys(userTags).forEach(key => {
      const type = userTags[key];
      const style = { background: fieldColorMap?.[type] ?? defaultAvatarStyle.background,
          border: 'none', color: '#000', paddingLeft: '10px', textTransform: 'capitalize',
            margin: '1px 0',
      };
      avatars.push(
          <Tag style={style}>{type}</Tag>
      );
    });
  }

  return avatars.length === 0 ? <div>---</div> : (
    <Row wrap={true} style={{maxWidth}}>
      {avatars}
    </Row>
  );
};

